module.exports = __webpack_public_path__ + "ae80d78a1d1cd0acc15d13b59089ecdb.png";